import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

const gallerySwiper = new Swiper('.gallery__swiper', {
  modules: [Autoplay, Navigation],

  loop: true,
  speed: 700,

  slidesPerView: 1.4,
  spaceBetween: 12,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },

  navigation: {
    prevEl: '.gallery__button--prev',
    nextEl: '.gallery__button--next',
  },

  breakpoints: {
    1440: {
      slidesPerView: 3.3,
      spaceBetween: 24,
    },
  },
});